import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { EnterpriseService } from "../../enterprise.service";

@Component({
  selector: "app-add-update-subscription-plan",
  templateUrl: "./add-update-subscription-plan.component.html",
  styleUrls: ["./add-update-subscription-plan.component.sass"],
})
export class AddUpdateSubscriptionPlanComponent implements OnInit, OnChanges {
  @Input() subscriptionData: any;
  @Input() showModal: boolean = false;

  @Output() closeModal = new EventEmitter<void>();
  @Output() save = new EventEmitter<any>();

  planForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private enterpriseService: EnterpriseService
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes["subscriptionData"] &&
      !changes["subscriptionData"].firstChange
    ) {
      this.patchForm();
    }
  }

buildForm() {
  this.planForm = this.fb.group({
    name: ["", Validators.required],
    planType: [1, Validators.required],
    price: [0, Validators.required],
    tax: [0, Validators.required],
    commission: [0, Validators.required],
    discount: [0, Validators.required],
    planIndex: [0, Validators.required],
    tripKM: [0, Validators.required],
    stopsPerTrip: [0, Validators.required],
    validityDays: [0, Validators.required],
    // extraKM: [0], // <-- NEW
  });

  this.planForm.get('planType')?.valueChanges.subscribe(v => {
    this.toggleFields(v);
  });
}
toggleFields(type: number) {

  const tripKM = this.planForm.get('tripKM');
  const validity = this.planForm.get('validityDays');
  // const extraKM = this.planForm.get('extraKM');

  if (type === 2) {
    // TOP UP
    // tripKM?.clearValidators();
      tripKM?.setValidators([Validators.required]);
    validity?.clearValidators();
    // extraKM?.setValidators([Validators.required]);

  } else {
    // MAIN PLAN
    tripKM?.setValidators([Validators.required]);
    validity?.setValidators([Validators.required]);
    // extraKM?.clearValidators();
  }

  tripKM?.updateValueAndValidity();
  validity?.updateValueAndValidity();
  // extraKM?.updateValueAndValidity();
}


  patchForm() {
    this.planForm.patchValue({
      name: this.subscriptionData?.name || "",
      planType: this.subscriptionData?.planType,
      price: this.subscriptionData?.price || 0,
      tax: this.subscriptionData?.tax || 0,
      commission: this.subscriptionData?.commission || 0,
      discount: this.subscriptionData?.discount || 0,
      planIndex: this.subscriptionData?.planIndex ?? 0,
      tripKM: this.subscriptionData?.tripKM ?? 0,
      extraKM:this.subscriptionData?.extraKM ?? 0,
      stopsPerTrip: this.subscriptionData?.stopsPerTrip ?? 0,
      validityDays: this.subscriptionData?.validityDays ?? 0,
    });
  }

  close() {
    this.closeModal.emit();
  }

  submit() {
    if (this.planForm.invalid) {
      this.planForm.markAllAsTouched();
      return;
    }

    let payload = {
      ...this.planForm.value,
      _id: this.subscriptionData?._id || null,
    };

    console.log("FORM SUBMIT => ", payload);

    this.spinner.show();

    if (payload._id) {
      console.log("in edit", payload);
      // UPDATE
      this.enterpriseService
        .updateSubscriptionPlan(payload, payload._id)
        .subscribe({
          next: (res: any) => {
            this.spinner.hide();

            if (res.statusCode == 200) {
              this.toastr.success("Plan updated successfully");
              this.closeModal.emit();
              this.save.emit(true);
            } else {
              this.toastr.error(res.message);
            }
          },
          error: (err) => {
            this.spinner.hide();
            this.toastr.error("Server error");
          },
        });
    } else {
      console.log("In Add", payload);
      // ADD
      this.enterpriseService.addSubscriptionPlan(payload).subscribe({
        next: (res: any) => {
          console.log("response", res)
          this.spinner.hide();
          if (res.statusCode == 201) {
            this.toastr.success(res.message);
            this.closeModal.emit();
            this.save.emit(true);
          } else {
            this.toastr.error(res.message);
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.toastr.error("Server error");
        },
      });
    }
  }
}
